var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 11.3333L8.66732 9.99998V6.57198C9.81465 6.27398 10.6673 5.23865 10.6673 3.99998C10.6673 2.52931 9.47132 1.33331 8.00065 1.33331C6.52998 1.33331 5.33398 2.52931 5.33398 3.99998C5.33398 5.23865 6.18665 6.27398 7.33398 6.57198V9.99998L8.00065 11.3333Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8453 7.04199L10.49 8.32732C12.2173 8.80465 13.334 9.72265 13.334 10.6667C13.334 11.928 11.144 13.3333 8.00065 13.3333C4.85732 13.3333 2.66732 11.928 2.66732 10.6667C2.66732 9.72265 3.78398 8.80465 5.51198 8.32665L5.15665 7.04132C2.79865 7.69332 1.33398 9.08199 1.33398 10.6667C1.33398 12.9093 4.26265 14.6667 8.00065 14.6667C11.7387 14.6667 14.6673 12.9093 14.6673 10.6667C14.6673 9.08199 13.2027 7.69332 10.8453 7.04199Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.7db31a0019cfdfe933c5d53eca8246a5.svg";
export { ForwardRef as ReactComponent };